<template>
  <div
    class="wing-container"
    :style="{
      'grid-template-rows': Array.from({ length: info.aircraftLength })
        .map(() => 'auto')
        .join(' '),
    }"
  >
    <div
      class="spacer"
      :style="{
        'grid-row': '1 / ' + info.startWingsRow,
      }"
    ></div>
    <div
      v-if="info.valid"
      class="wing-wrapper"
      :style="{
        'grid-row': info.startWingsRow + ' / ' + info.endWingsRow,
      }"
    >
      <div :class="'wing wing-' + info.direction"></div>
    </div>
    <div
      class="spacer"
      :style="{
        'grid-row': info.endWingsRow + ' / -1',
      }"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'wing',
  props: {
    info: Object,
  },
};
</script>

<style lang="scss">
.wing-container {
  flex-grow: 1;
  display: grid;
  gap: 5px;
  padding-top: 30px;
}

.wing-wrapper {
  overflow: hidden;
}

.wing {
  min-height: 100%;
  background: #eef3ff;
  &-left {
    margin-right: 5px;
    clip-path: polygon(0% 10%, 100% 0%, 100% 100%, 0% 100%);
    background: linear-gradient(
      -90deg,
      rgba(238, 243, 255, 1) 0%,
      rgba(238, 243, 255, 0.75) 30%,
      rgba(238, 243, 255, 0.5) 70%,
      rgba(238, 243, 255, 0.25) 100%
    );
  }
  &-right {
    margin-left: 5px;
    clip-path: polygon(0% 0%, 100% 10%, 100% 100%, 0% 100%);
    background: linear-gradient(
      90deg,
      rgba(238, 243, 255, 1) 0%,
      rgba(238, 243, 255, 0.75) 30%,
      rgba(238, 243, 255, 0.5) 70%,
      rgba(238, 243, 255, 0.25) 100%
    );
  }
  min-width: 10px;
}
</style>
